import { request } from '../smart_bps/lib/utils'

export function fetchEntities(callback) {
  request({
    method: 'get',
    url: '/api/widgets/entities',
    success: (data) => callback(null, data.entities || []),
    error: (err) => callback(err || new Error('Ошибка загрузки списка разделов')),
  })
}

export function fetchFilterMeta(entity, callback) {
  if (!entity) {
    callback(null, [])
    return
  }
  request({
    method: 'get',
    url: `/api/widgets/filter_meta?entity=${encodeURIComponent(entity)}`,
    success: (data) => callback(null, data.fields || []),
    error: (err) => callback(err || new Error('Ошибка загрузки фильтров'), []),
  })
}

export function fetchWidgetData(config, callback) {
  request({
    method: 'post',
    url: '/api/widgets/data',
    data: config,
    success: (data) => callback(null, data),
    error: (err) => callback(err || new Error('Ошибка загрузки данных')),
  })
}
